export default "__VITE_ASSET__2Bz8fQz6__"